'use strict';

/**
 * Global actions for the 360Store
 * @ngdoc function
 * @name 360StoreAngularApp.controller:360storeControllerCtrl
 * @description
 * # 360storeControllerCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('StoreCtrl', function ($rootScope, $uibModal, api, BUILD_DATE) {
		$rootScope.autoRenewTermsAndConditions = () => {
			$uibModal.open({
				templateUrl: 'views/modal-auto-renew-terms-and-conditions.html?v=' + BUILD_DATE,
				size:'md',
			}).result.catch(() => {
			});
		};

		$rootScope.editOrderModal = async function (o) {
			o.cartItems[0].rootCartItem = await api.get('api/admin/root-cart-item', {params: {cartItemId: o.cartItems[0].id}});
			return $uibModal.open({
				controller: 'OrderEditCtrl',
				templateUrl: 'views/modal-order-edit.html?v=' + BUILD_DATE,
				size: 'lg',
				resolve: {
					order: o,
					user: function (api) {
						return api.adminCurrentUser();
					}
				}
			}).result;
		};

		$rootScope.viewMarkdownModal = (markdown, options) => {
			let scope = $rootScope.$new(true);
			scope.markdown = markdown;
			scope.options = options;
			return $uibModal.open({
				templateUrl: 'views/modal-markdown-viewer.html?v=' + BUILD_DATE,
				scope: scope
			}).result;
		};

		$rootScope.editOrderModalById = async (orderId) => {
			let orders = await api.get('api/admin/orders', {params:{cartId: orderId}});
			return $rootScope.editOrderModal(orders[0]);
		}

		$rootScope.editOrderModalByCartItemId = async (orderId) => {
			let orders = await api.get('api/admin/orders', {params:{cartItemId: orderId}});
			return $rootScope.editOrderModal(orders[0]);
		}

	});
